import { useState as d, useLayoutEffect as c } from "react";
import { HEADER_HEIGHT as P } from "../../styles/variables.js";
function S({
  childrenRef: n,
  FloatingElementRef: h,
  elementMargin: s,
  hasHeader: g
}) {
  const [t, f] = d(
    {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    }
  ), [e, u] = d({ width: 0, height: 0 }), l = e.width || 0, m = e.height || 0, p = t.width / 2, r = g ? P : 0;
  c(() => {
    if (!n.current)
      return;
    const { left: i, width: o, height: E, bottom: a } = n.current.getBoundingClientRect();
    f({
      top: a,
      left: i,
      width: o,
      height: E
    });
  }, []), c(() => {
    if (!h.current)
      return;
    const { width: i, height: o } = h.current.getBoundingClientRect();
    u({
      width: i,
      height: o
    });
  }, []);
  const w = {
    top: t.top - t.height - m - s - r,
    bottom: t.top + s - r,
    left: t.left - l + t.width + 8,
    middle: t.left - l / 2 + p,
    right: t.left - 8
  };
  return {
    childrenPositions: {
      top: t.top,
      left: t.left,
      width: t.width,
      height: t.height
    },
    floatingElementPosition: w,
    floatingElementSizes: e
  };
}
export {
  S as useGetFloatingElementPosition
};
